import { addEffect, applyProps } from '@react-three/fiber';
import { Globals } from '@react-spring/core';
export * from '@react-spring/core';
import { createStringInterpolator, colors, raf } from '@react-spring/shared';
import { createHost } from '@react-spring/animated';
import * as THREE from 'three';
var primitives = ['primitive'].concat(Object.keys(THREE).filter(function (key) {
  return /^[A-Z]/.test(key);
}).map(function (key) {
  return key[0].toLowerCase() + key.slice(1);
}));
Globals.assign({
  createStringInterpolator: createStringInterpolator,
  colors: colors,
  frameLoop: 'demand'
});
addEffect(function () {
  raf.advance();
});
var host = createHost(primitives, {
  applyAnimatedValues: applyProps
});
var animated = host.animated;
export { animated as a, animated };